/**
 * @generated SignedSource<<9b2c747d1908874d7ea0e5b643acbcb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type PreviewWidgetSignalOverviewInput = {
  size: WidgetOverviewSize;
  storecastId?: string | null;
  teamIds?: ReadonlyArray<string> | null;
};
export type WidgetSignalOverviewPreviewQuery$variables = {
  input: PreviewWidgetSignalOverviewInput;
  storecastId: string;
};
export type WidgetSignalOverviewPreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetSignalOverview: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetSignalOverview_widget">;
    };
  };
};
export type WidgetSignalOverviewPreviewQuery = {
  response: WidgetSignalOverviewPreviewQuery$data;
  variables: WidgetSignalOverviewPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = [
  (v4/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetSignalOverviewPreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "WidgetSignalOverview",
              "kind": "LinkedField",
              "name": "previewWidgetSignalOverview",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetSignalOverview_widget"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetSignalOverviewPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "WidgetSignalOverview",
            "kind": "LinkedField",
            "name": "previewWidgetSignalOverview",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": "signalContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v8/*: any*/),
                        "concreteType": "SignalConnection",
                        "kind": "LinkedField",
                        "name": "signals",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SignalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Signal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "priority",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoreZonedDate",
                                    "kind": "LinkedField",
                                    "name": "publishedAtDate",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "style",
                                            "value": "DEFAULT"
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "storeFormattedDate",
                                        "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "employeeReceiverReceiptsCount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Store",
                                    "kind": "LinkedField",
                                    "name": "store",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "employeeCount",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoreProduct",
                                    "kind": "LinkedField",
                                    "name": "linkedProducts",
                                    "plural": true,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "descriptionImages",
                                    "plural": true,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "descriptionFiles",
                                    "plural": true,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__id",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": "signals(first:20)"
                      },
                      {
                        "alias": null,
                        "args": (v8/*: any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "WidgetSignalOverviewContentMedium__signals",
                        "kind": "LinkedHandle",
                        "name": "signals"
                      }
                    ],
                    "type": "WidgetSignalOverviewContentMedium",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3b2ce4c2300ebaf15fcbd6871d959d8b",
    "id": null,
    "metadata": {},
    "name": "WidgetSignalOverviewPreviewQuery",
    "operationKind": "query",
    "text": "query WidgetSignalOverviewPreviewQuery(\n  $storecastId: ID!\n  $input: PreviewWidgetSignalOverviewInput!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetSignalOverview(input: $input) {\n      ...WidgetSignalOverview_widget\n      id\n    }\n    id\n  }\n}\n\nfragment SignalOverviewListItemMedium_Signal on Signal {\n  id\n  title\n  priority\n  publishedAtDate {\n    ...StoreFormattedDate\n  }\n  employeeReceiverReceiptsCount\n  store {\n    employeeCount\n    id\n  }\n  linkedProducts {\n    id\n  }\n  descriptionImages {\n    id\n  }\n  descriptionFiles {\n    id\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment WidgetSignalOverviewContentMediumPaginated on WidgetSignalOverview {\n  teams {\n    id\n  }\n  signalContent: content {\n    __typename\n    ... on WidgetSignalOverviewContentMedium {\n      signals(first: 20) {\n        edges {\n          node {\n            id\n            ...SignalOverviewListItemMedium_Signal\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n  id\n}\n\nfragment WidgetSignalOverview_widget on WidgetSignalOverview {\n  id\n  title\n  teams {\n    id\n  }\n  ...WidgetSignalOverviewContentMediumPaginated\n}\n"
  }
};
})();

(node as any).hash = "1358989eb5622576b94d1741a1da5535";

export default node;
